// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TzD8","content":"styles_content__dsB5I","row":"styles_row__3HgXk","footer":"styles_footer__2P8hH","phraseLength":"styles_phraseLength__kFz06"};